import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getMeetingDetail } from '../api/meetingApi'

/**
 * Toplantı (tutanak) detayı sunucu-durumu (044). id geçersizse sorgu pasif.
 *
 * <p>Aktif dil ({@code i18n.language}) key'e girer: yanıttaki REFERANS adları (görev tablosundaki
 * {@code statusName} başta olmak üzere) sunucuda {@code Accept-Language}'e göre çözülür, yani kayıt
 * <b>dile özgüdür</b>. Dil key'de olmazsa TR↔EN geçişinde önceki dilin cache'i taze sayılır ve durum
 * adları eski dilde kalır (kullanıcı bulgusu) — {@code useActions}/{@code useActionStatuses} ile aynı kalıp.
 */
export function useMeetingDetail(id: number | null) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['meeting-detail', id, i18n.language],
    queryFn: () => getMeetingDetail(id as number),
    enabled: id != null && !Number.isNaN(id),
  })
}
